"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Component = require("./Component");
Object.keys(_Component).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Component[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Component[key];
    }
  });
});
var _Region = require("./Region");
Object.keys(_Region).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Region[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Region[key];
    }
  });
});
var _Page = require("./Page");
Object.keys(_Page).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Page[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Page[key];
    }
  });
});
var _propTypes = require("./prop-types");
Object.keys(_propTypes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _propTypes[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _propTypes[key];
    }
  });
});